module.exports = __webpack_public_path__ + "img/c.2348f712.jpg";